// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as OnboardingTemplate from "./OnboardingTemplate.bs.jsx";

function OnboardingThrustDevice(props) {
  let onThrust = props.onThrust;
  let onSkip = props.onSkip;
  return <OnboardingTemplate.make>
    <h2>
      {"Ukládání dat"}
    </h2>
    <p
      className={Styles.fieldset.gridSpan}
    >
      {`Aplikace umí pracovat i bez internetu`}
      {props.mentionWebAuthn ? ` nebo přihlašování bez hesla, například otiskem prstu nebo obličejem.` : `.`}
      {` K tomu potřebuje ukládat data do zařízení.`}
    </p>
    <p>
      {"Pokud serfuješ na cizím počítači a nechceš aby se k datům dostal někdo cizí, tento krok přeskoč."}
    </p>
    <button
      className={Styles.button.base}
      type={"button"}
      onClick={param => onThrust()}
    >
      {`Tomuto zařízení důvěřuji`}
    </button>
    <button
      className={Styles.link.base}
      type={"button"}
      onClick={param => onSkip()}
    >
      {`Na tomto zařízení nechci ukládat svá data`}
    </button>
  </OnboardingTemplate.make>;
}

let make = OnboardingThrustDevice;

export {
  make,
}
/* Styles Not a pure module */
